import { styled } from '@mui/system';

export const Wrapper = styled('div')``;

export const Form = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
export const Actions = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;

  > div {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;
